var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83398 15.5C2.37565 15.5 1.98329 15.3368 1.6569 15.0104C1.33051 14.684 1.16732 14.2917 1.16732 13.8333V3H0.333984V1.33333H4.50065V0.5H9.50065V1.33333H13.6673V3H12.834V13.8333C12.834 14.2917 12.6708 14.684 12.3444 15.0104C12.018 15.3368 11.6257 15.5 11.1673 15.5H2.83398ZM4.50065 12.1667H6.16732V4.66667H4.50065V12.1667ZM7.83398 12.1667H9.50065V4.66667H7.83398V12.1667Z",
    fill: "#D32F2F",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteError);
export default __webpack_public_path__ + "static/media/icon-delete-error.9580e0eb4ed6685bd7b7df87e49b0398.svg";
export { ForwardRef as ReactComponent };